import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.75 3H17.5v-.75a.75.75 0 1 0-1.5 0V3H8.5v-.75a.75.75 0 0 0-1.5 0V3H4.75a1.5 1.5 0 0 0-1.5 1.5v15a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5M7 4.5v.75a.75.75 0 0 0 1.5 0V4.5H16v.75a.75.75 0 1 0 1.5 0V4.5h2.25v3h-15v-3zm12.75 15h-15V9h15zm-3.594-8.03a.747.747 0 0 1 0 1.06l-4.5 4.5a.747.747 0 0 1-1.062 0l-2.25-2.25a.75.75 0 1 1 1.062-1.06l1.719 1.72 3.97-3.97a.747.747 0 0 1 1.06 0"
    }, null, -1)
  ]))]))
}
export default { render: render }